import React from 'react';
import Icon from './Icon';

/**
 * SealChip — recurring "officiellt / verifierat" proof chip (DESIGN-SPEC 3.2).
 * The red thread across landing → pricing → billing → exam.
 *
 * Props:
 *  - label: string            text from config (language-agnostic)
 *  - icon?: string            Icon name (default "seal")
 *  - tone?: "indigo"|"neutral"  brand indigo (default) or off-brand slate
 *  - className?: string       extra classes
 *
 * Recolor-safe: brand styling via indigo-* + ring-indigo-600 only.
 */
const TONES = {
  indigo: 'ring-indigo-600/20 bg-indigo-50 text-indigo-800',
  neutral: 'ring-slate-300 bg-slate-50 text-slate-500',
};

export default function SealChip({
  label,
  icon = 'seal',
  tone = 'indigo',
  className = '',
}) {
  const toneClasses = TONES[tone] || TONES.indigo;

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full ring-1 ${toneClasses} px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide${className ? ` ${className}` : ''}`}
    >
      <Icon name={icon} className="w-3.5 h-3.5" />
      {label}
    </span>
  );
}
